import {
  InfiniteData,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
  api,
  ContactsListDto,
  InferSearchParamsQueryType,
  QueryKey,
} from '@sib/api';

interface UseInfiniteClientContactsProps {
  organizationId: string;
  payload: InferSearchParamsQueryType<
    typeof api.organization.organizationContactsControllerGetOrganizationContacts,
    1,
    false
  >;
  options?: Partial<
    UseInfiniteQueryOptions<
      ContactsListDto,
      Error,
      InfiniteData<ContactsListDto>
    >
  >;
}

export const useInfiniteClientContacts = ({
  organizationId,
  payload,
  options,
}: UseInfiniteClientContactsProps) =>
  useInfiniteQuery({
    ...options,
    queryKey: [
      QueryKey.Resource.ClientContacts,
      QueryKey.Operation.List,
      organizationId,
      payload,
      QueryKey.Operation.Infinite,
    ],
    queryFn: ({ pageParam }) =>
      api.organization.organizationContactsControllerGetOrganizationContacts(
        organizationId,
        {
          ...payload,
          page: pageParam as number,
        }
      ),
    getNextPageParam: lastPage =>
      lastPage.hasNextPage ? lastPage.page + 1 : undefined,
    initialPageParam: payload.page,
  });

interface UseInfiniteVendorContactsProps {
  organizationId: string;
  payload: InferSearchParamsQueryType<
    typeof api.organization.organizationContactsControllerGetAllVendorContactsOfOrganization,
    1,
    false
  >;
  options?: Partial<
    UseInfiniteQueryOptions<
      ContactsListDto,
      Error,
      InfiniteData<ContactsListDto>
    >
  >;
}

export const useInfiniteVendorContacts = ({
  organizationId,
  payload,
  options,
}: UseInfiniteVendorContactsProps) =>
  useInfiniteQuery({
    ...options,
    queryKey: [
      QueryKey.Resource.VendorContacts,
      QueryKey.Operation.List,
      organizationId,
      payload,
      QueryKey.Operation.Infinite,
    ],
    queryFn: ({ pageParam }) =>
      api.organization.organizationContactsControllerGetAllVendorContactsOfOrganization(
        organizationId,
        {
          ...payload,
          page: pageParam as number,
        }
      ),
    getNextPageParam: lastPage =>
      lastPage.hasNextPage ? lastPage.page + 1 : undefined,
    initialPageParam: payload.page,
  });
